import { useLiveQuery } from 'dexie-react-hooks'
import { Link } from 'react-router-dom'

import { mesurerNuit } from '../../analysis/nuits'
import { db } from '../../db/db'
import { lireReglages } from '../../db/repo'
import { formatDuree, formatHeure, formatJourCourt } from '../../domain/time'
import type { Nuit } from '../../domain/types'
import { Carte, Entete, IconeChevron, IconePlus, Puce } from '../composants'

export function PageNuits() {
  const donnees = useLiveQuery(async () => {
    const nuits = await db.nuits.toArray()
    nuits.sort((a, b) => b.date.localeCompare(a.date))
    return { nuits, reglages: await lireReglages() }
  }, [])

  return (
    <>
      <Entete
        titre="Journal"
        sous={donnees ? `${donnees.nuits.length} nuit${donnees.nuits.length > 1 ? 's' : ''}` : undefined}
        action={
          <Link className="btn btn--petit" to="/nuits/nouvelle" aria-label="Ajouter une nuit">
            <IconePlus />
          </Link>
        }
      />

      <main className="contenu">
        {!donnees ? (
          <p className="doux">Chargement…</p>
        ) : donnees.nuits.length === 0 ? (
          <Carte>
            <p className="doux">
              Aucune nuit pour l’instant. Les nuits arrivent d’elles-mêmes une fois les
              raccourcis configurés, ou peuvent être saisies à la main.
            </p>
            <p style={{ marginTop: 12 }}>
              <Link className="btn btn--principal btn--bloc" to="/installation">
                Configurer les raccourcis
              </Link>
            </p>
          </Carte>
        ) : (
          <ul className="liste">
            {donnees.nuits.map((n) => (
              <li key={n.date}>
                <LigneNuit nuit={n} objectifMinutes={donnees.reglages.objectifMinutes} />
              </li>
            ))}
          </ul>
        )}
      </main>
    </>
  )
}

function LigneNuit({ nuit, objectifMinutes }: { nuit: Nuit; objectifMinutes: number }) {
  const m = mesurerNuit(nuit)
  const atteint = m.tempsPoseMs >= objectifMinutes * 60_000

  return (
    <Link className="item" to={`/nuits/${nuit.date}`}>
      <div className="grandir">
        <div className="item__principal">
          {formatJourCourt(nuit.date)}
          <span className="mono"> · {formatDuree(m.tempsPoseMs)}</span>
        </div>
        <div className="item__secondaire mono">
          {formatHeure(nuit.debut)} → {formatHeure(nuit.fin)}
          {m.reveils > 0 && ` · ${m.reveils} réveil${m.reveils > 1 ? 's' : ''}`}
        </div>
      </div>
      {nuit.source === 'heuristique' && <Puce ton="alerte">estimée</Puce>}
      {nuit.source === 'manuel' && <Puce ton="info">saisie</Puce>}
      {atteint && nuit.source === 'raccourci' && <Puce ton="ok">objectif</Puce>}
      <span className="chevron">
        <IconeChevron />
      </span>
    </Link>
  )
}
